import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { Box } from '@material-ui/core';

HawkOwlLogo.propTypes = {
  size: PropTypes.number,
  showGlow: PropTypes.bool,
  sx: PropTypes.object
};

export default function HawkOwlLogo({ size = 32, showGlow = false, sx }) {
  const gradientId = useMemo(
    () => `hawkowl-bg-${Math.random().toString(36).slice(2, 9)}`,
    []
  );

  return (
    <Box
      sx={{
        position: 'relative',
        width: size,
        height: size,
        flexShrink: 0,
        ...sx
      }}
    >
      {showGlow && (
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            inset: -size * 0.25,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(18, 231, 255, 0.6) 0%, transparent 70%)',
            filter: 'blur(8px)',
            opacity: 0.6
          }}
        />
      )}
      <Box
        component="svg"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={{
          position: 'relative',
          display: 'block',
          width: size,
          height: size
        }}
      >
        <defs>
          <linearGradient id={gradientId} x1="8" y1="4" x2="56" y2="60" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#063B78" />
            <stop offset="100%" stopColor="#00A6D6" />
          </linearGradient>
        </defs>
        <circle cx="32" cy="32" r="30" fill={`url(#${gradientId})`} />
        <line x1="32" y1="2" x2="32" y2="8" stroke="#12E7FF" strokeWidth="1.5" opacity="0.6" />
        <line x1="32" y1="56" x2="32" y2="62" stroke="#12E7FF" strokeWidth="1.5" opacity="0.6" />
        <line x1="2" y1="32" x2="8" y2="32" stroke="#12E7FF" strokeWidth="1.5" opacity="0.6" />
        <line x1="56" y1="32" x2="62" y2="32" stroke="#12E7FF" strokeWidth="1.5" opacity="0.6" />
        <circle cx="23" cy="28" r="9" fill="white" />
        <circle cx="41" cy="28" r="9" fill="white" />
        <circle cx="23" cy="28" r="4.5" fill="#0B1F33" />
        <circle cx="41" cy="28" r="4.5" fill="#0B1F33" />
        <circle cx="24.5" cy="26.5" r="1.4" fill="#12E7FF" />
        <circle cx="42.5" cy="26.5" r="1.4" fill="#12E7FF" />
        <path d="M32 34 L28 40 L36 40 Z" fill="#FF8A00" />
        <path d="M14 16 L20 22 L18 14 Z" fill="#FF8A00" />
        <path d="M50 16 L44 22 L46 14 Z" fill="#FF8A00" />
        <line x1="32" y1="46" x2="32" y2="52" stroke="#FF8A00" strokeWidth="2" strokeLinecap="round" />
      </Box>
    </Box>
  );
}
